module.exports = __webpack_public_path__ + "static/media/A4 - 4.9724d611.png";